import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=be6dcb32&"
import script from "./CartPage.vue?vue&type=script&lang=js&"
export * from "./CartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports